import React from "react";
import cx from "classnames";
interface SvgProps {
  icon: string;
  style?: WithUndefined<any>;
  className?: string;
}

const XtSvg: React.FC<SvgProps> = ({ className, icon, style }) => {
  if (icon === "close") {
    return (
      <svg
        className={cx("iconpark-icon", className)}
        style={style}
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.53217 8.00008L6.10352e-05 1.46805L0.734047 0.734064L1.46803 7.85754e-05L8.00014 6.53211L14.5321 0L15.2661 0.733986L16.0001 1.46797L9.46811 8.00008L16 14.532L14.532 16L8.00014 9.46805L1.46795 16.0002L0.733968 15.2662L-1.76021e-05 14.5322L6.53217 8.00008Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg className={cx("iconpark-icon", className)} style={style}>
      <use href={"#" + icon}></use>
    </svg>
  );
};

export default XtSvg;
